import { render, staticRenderFns } from "./footer-links.vue?vue&type=template&id=3dbac19c&"
import script from "./footer-links.vue?vue&type=script&lang=js&"
export * from "./footer-links.vue?vue&type=script&lang=js&"
import style0 from "./footer-links.vue?vue&type=style&index=0&id=3dbac19c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports